import { render, staticRenderFns } from "./nextIndex.vue?vue&type=template&id=2c6413ec&scoped=true&"
import script from "./nextIndex.vue?vue&type=script&lang=js&"
export * from "./nextIndex.vue?vue&type=script&lang=js&"
import style0 from "./nextIndex.vue?vue&type=style&index=0&id=2c6413ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6413ec",
  null
  
)

export default component.exports